import React, { FC, useContext } from 'react';
import { FormattedMessage } from 'react-intl';
import { Hyperlink } from '../../../components/Hyperlink';
import { withFeatures } from '../../../features/withFeatures';
import { UserContext } from '../../../user/UserContext';

export const RawNavUserReferral: FC = () => {
  const { currentUser, REFERRAL_AMOUNT } = useContext(UserContext);

  if (!currentUser.canHaveReferralCode) return null;

  return (
    <li className="nav-referral-profile">
      <Hyperlink
        className="nav-user-dropdown__link nav-user-dropdown__highlight"
        href="/parrainage?source=nav_dropdown"
      >
        <FormattedMessage
          id="navigation/user/components/NavUserReferral.tsx/1"
          values={{ amount: REFERRAL_AMOUNT }}
        />
      </Hyperlink>
    </li>
  );
};

export const NavUserReferral = withFeatures('referral')(RawNavUserReferral);
